module.exports = __webpack_public_path__ + "static/media/receta-14.9f25f7dd.png";